export default function formatNumber(value: number, decimals: number = 0, decimal_separator: string = ' '): string {
	return value.toFixed(decimals).replace(/\d(?=(\d{3})+(\.|$))/g, '$&' + decimal_separator);
}
